import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Form from 'deltoid/core/Form';
import { Row, Col } from 'deltoid/core/Blocks/BootstrapContainers';
import { Body, Caption, Small } from 'deltoid/core/Blocks/Typography';
import Timer from '@components/BaseComponents/Timer';

const VerifyOTP = ({
  heading,
  title,
  subTitle,
  handleVerifyOTP,
  goBack,
  errMsg: errMsgProp,
  resendOtp,
  retryTime,
  onTimerComplete,
  disableResend,
  otpLength,
  hint,
  disableVerifyBtn,
  loadingVerifyBtn,
  label,
}) => {
  const [errMsg, setErrMsg] = useState(errMsgProp);  
  const [otpValue, setOtpValue] = useState(null);

  useEffect(() => { setErrMsg(errMsgProp) }, [errMsgProp]);

  return (
    <Row noGutters>
      <Col>
        <Body variant='bold' className='p-3 mb-3 border-bottom'>{heading}</Body>
        <Caption className='pl-3 pr-3'>{title}</Caption>
        <p className='oui-small oui-font-regular pl-3 pr-3 mb-2 pt-1'>{subTitle}</p>
        <Form.Group className='pl-3 pr-3'>
          <Form.OTP
            length={otpLength}
            shouldAutoFocus
            onChange={(v) => {
              setOtpValue(v);
              setErrMsg(false);
            }}
            className='test-otp-class'
            label={label}
          />
          {errMsg && <Form.Message type='error'>{errMsg}</Form.Message>}
        </Form.Group>
        {resendOtp && (
          <Row className='pr-3 pl-3 pb-3' noGutters>
            <Col className='text-right'>
              <Form.Button variant='underlined' type='button'
                onClick={() => {resendOtp(); setErrMsg(false);}}
                style={{height: 'fit-content'}}
                disabled={disableResend}
              >
                Resend OTP
              </Form.Button>
              {retryTime && <Timer interval={retryTime} onComplete={onTimerComplete}/>}
            </Col>
          </Row>
        )}
        { hint && (
          <div className='co-bg-yellow-tint p-3 ml-3 mr-3 mb-3'>
            <Small>{hint}</Small>
          </div>
        )}
        <div className='d-flex justify-content-between p-3 bg-light'>
          <Form.Button className='bg-white border text-dark' type='button' onClick={goBack}>
            Go Back
          </Form.Button>
          <Form.Button
            type='button'
            onClick={() => handleVerifyOTP(otpValue)}
            disabled={disableVerifyBtn}
            loading={loadingVerifyBtn}
          >
            Verify OTP
          </Form.Button>
        </div>
      </Col>
    </Row>
  )
};

VerifyOTP.propTypes = {
  heading: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  handleVerifyOTP: PropTypes.func,
  goBack: PropTypes.func,
  errMsg: PropTypes.string,
  resendOtp: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  retryTime: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  onTimerComplete: PropTypes.func,
  disableResend: PropTypes.bool,
  otpLength: PropTypes.number,
  hint: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disableVerifyBtn: PropTypes.bool,
  loadingVerifyBtn: PropTypes.bool,
  label: PropTypes.string,
}

VerifyOTP.defaultProps = {
  heading: '',
  title: '',
  subTitle: '',
  handleVerifyOTP: () => {},
  goBack: () => {},
  errMsg: null,
  resendOtp: false,
  retryTime: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  onTimerComplete: () => {},
  disableResend: false,
  otpLength: 4,
  hint: false,
  disableVerifyBtn: false,
  loadingVerifyBtn: false,
  label: 'otp-input-',
}

export default VerifyOTP;
